const highlight = {
	attrs: { color: { default: null } },
};

export default highlight;
